import * as React from 'react';
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';

export type Column<Row> = { header: string, cell: (row: Row) => React.ReactNode, numeric?: boolean };

// The numbers behind a chart (or a list worth reading as one), in a plain table.
export function DataTable<Row>({columns, rows, label, maxHeight = 320}: { columns: Column<Row>[], rows: Row[], label: string, maxHeight?: number }) {
    return (
        <TableContainer tabIndex={0} role="region" aria-label={label} sx={{maxHeight, border: 1, borderColor: 'divider', borderRadius: 1.25}}>
            <Table size="small" stickyHeader aria-label={label}>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => <TableCell key={column.header} align={column.numeric ? 'right' : 'left'}>{column.header}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, i) => (
                        <TableRow key={i} hover sx={{'&:last-child td': {borderBottom: 0}}}>
                            {columns.map((column) => <TableCell key={column.header} align={column.numeric ? 'right' : 'left'}>{column.cell(row)}</TableCell>)}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {rows.length === 0 && <Box sx={{p: 2, color: 'text.secondary'}}>Nothing in this period.</Box>}
        </TableContainer>
    );
}
